<template>
    <section
        v-if="faqs && faqs.length > 0"
        class="Faqs"
    >
        <h2 class="FaqsTitle">Frequently Asked Questions</h2>
        <ul class="FaqContent">
            <li v-for="(faq, index) in faqs" :key="index" class="FaqListItem">
                <FaqItem :id="index" :question="faq.question" :answer="faq.answer" :active="isOpened(index)" @toggle="toggleFaq(index)" />
            </li>
        </ul>
    </section>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { useMobile } from '@composables/useMobile';
import FaqItem from './FaqItem/FaqItem.vue';
import { useSearchStore } from '@app/stores/useSearchStore';

// TODO: Make it search type specific in the future

const store = useSearchStore();
const pageData = computed(() => store.pageData);
const openIndexes = ref<number[]>([]);
const faqs = computed(() => pageData.value?.faqs || []);
const {isMobile} = useMobile();

const toggleFaq = (index: number) => {
    if(isMobile.value) {
        openIndexes.value = openIndexes.value[0] === index ? [] : [index];
        return;
    }
    if (openIndexes.value.includes(index)) {
        openIndexes.value = openIndexes.value.filter(i => i !== index);
    } else {
        openIndexes.value.push(index);
    }
};

const isOpened = computed(()=> (index: number) => openIndexes.value.includes(index));
watch(faqs, () => {
    openIndexes.value = [];
})
</script>

<style scoped lang="scss">
.Faqs {
    height: fit-content;
    background-color: $White;
    border-radius: 0.5rem;
    @include PaddingAreas(1.5, 1, 1.5, 1);
    .FaqContent {
        list-style-type: none;
        @include PaddingAreas(0);
        @include MarginAreas(0);
    }

    .FaqsImage {
        @include Breakpoint(ExtraLarge, Large) {
            width: 30rem;
        }
    }

    .FaqsTitle {
        text-align: center;
        color: $Grey-900;
        @include MarginAreas(0, 0, 1.5, 0);
        @include TextStyle(HeadingSmall);
        @include Breakpoint(Large, ExtraLarge) {
            @include TextStyle(HeadingMedium);
        }
    }

    .FaqListItem {
        list-style-type: none;
        border-bottom: 1px solid $Grey-200;

        @include MarginAreas(0);

        .FaqItem > :first-child {
            @include TextStyle(UiMediumRegular);
        }
    }
}
</style>